<template>
  <div id="speakers-wrapper">
    <app-header></app-header>

    <div class="container"
         v-for="key in eventKeys"
         v-bind:key="key">
      <router-link tag="a" :to="'/event/' + key">
        <h2 class="event-name">{{ events[key].name }} "{{ events[key].theme }}"</h2>
      </router-link>
      <speaker-list :speakers="speakers[key]"></speaker-list>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SpeakerList from '@/components/SpeakerList';
import SpeakersData from '@/assets/speakers.json';
import EventsData from '@/assets/events.json';


export default {
  name: 'Speakers',
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'speaker-list': SpeakerList,
  },
  data() {
    return {
      speakers: SpeakersData,
      events: EventsData,
      eventKeys: ['swing_by', 'shizuku', 'rock_your_mind'],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

#speakers-wrapper {
  margin-top: 96px;
  padding: 0;
}

.event-name {
  margin: 24px 8px 2px 12px;

  @include media-breakpoint-down(md) {
    margin: 0 8px 4px 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Speakers.vue